import React, { useEffect } from 'react'
import { isEmpty } from 'lodash'
import { fetchApplicationSessionInformation } from '../queries/applicationSessionInformation.js'
import { ApplicationContextShape, useApplicationContext } from '../context'
import useGraphNotificationSubscriptionHook from './notification/graphNotificationSubscriptionHook'
import { transformGraphNotification } from './notification/transformer.js'

export const useApplicationSessionInformation = () => {
  const { logger, user, notifications, setNotifications, actions } =
    useApplicationContext()

  const { data: notificationsData, pagination: notificationsPagination } =
    notifications

  let incomingNotification = null

  const { notification } = useGraphNotificationSubscriptionHook()
  incomingNotification = notification

  useEffect(() => {
    const fetchPostAuthenticationUserData = async () => {
      await fetchApplicationSessionInformation({
        page: notificationsPagination.page,
        take: notificationsPagination.take,
        channel: 'WEB',
        displayed: true,
      })
        .then(res => {
          const { onboarding_answers, purchase_profiles } = res

          actions.updateUser({
            onboarding_answers,
            purchase_profiles,
          })

          if (!res.notifications?.content) return
          const pagination = {
            ...notificationsPagination,
            totalPages: res.notifications.total_pages,
            totalElements: res.notifications.total_elements,
          }
          return setNotifications({
            ...notifications,
            pagination,
            data: [
              ...notificationsData,
              ...res.notifications.content.map(transformGraphNotification),
            ],
          })
        })
        .catch(e => {
          logger.error(
            'useApplicationSessionInformation: error fetching user notifications',
            e
          )
        })
    }

    if (user.logged_in) {
      fetchPostAuthenticationUserData()
    } else if (!user.logged_in) {
      setNotifications(ApplicationContextShape.notifications)
    }
  }, [user.logged_in])

  useEffect(() => {
    if (isEmpty(incomingNotification)) return
    setNotifications(notificationsContext => ({
      ...notificationsContext,
      data: [
        transformGraphNotification(incomingNotification),
        ...notificationsContext.data,
      ],
    }))
  }, [incomingNotification])

  return { notifications, setNotifications }
}

export const withNotifications = Component => props => {
  const { notifications, setNotifications } = useApplicationSessionInformation()

  return (
    <Component
      notifications={notifications}
      setNotifications={setNotifications}
      {...props}
    />
  )
}
